// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2GOEF","header":"ClearentDisclaimer_header__2cTAd","inner":"ClearentDisclaimer_inner__2UEV9"};